/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { useHistory } from 'react-router-dom';
import { LoneIconButton } from '@blend/enterprise-components';

import { HelpAction } from 'blb-components/AuthenticatedApp/HelpAction';
import { UserIconButton } from 'blb-components/AuthenticatedApp/UserIconButton';
import { MeContext } from 'blb-contexts/Me';
import { goBackToPipeline } from 'blb-utils/misc';

export const styles = StyleSheet.create({
  clickable: {
    display: 'flex',
    justifyContent: 'center',
  },
});

export namespace Sidebar {
  export interface Props {}
}

export const Sidebar: React.FC<Sidebar.Props> = ({}) => {
  const history = useHistory();
  const me = React.useContext(MeContext)!;
  return (
    <>
      <div className={css(styles.clickable)}>
        <LoneIconButton
          btnSize="sm"
          icon="arrow_back"
          iconSize={24}
          onClick={() => {
            me.principalType === 'insurance_qc_agent' ? history.push('/qc-search') : goBackToPipeline(history);
          }}
          theme="light"
        />
      </div>
      <div>
        <UserIconButton />
        <HelpAction />
      </div>
    </>
  );
};
